import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'htmlToPlaintext',
    standalone: true
})
export class HtmlToPlaintextPipe implements PipeTransform {
    transform(value: any): string {
        if (!value) return '';
        return value
            .replace(/<br\s*\/?>/g, '\n') // Convert <br> to \n
            .replace(/<\/?[^>]+(>|$)/g, ''); // Strip all other HTML tags
    }
}
